<template>
  <div class="bdf">
    <div class="bdf-head">
      <span class="bdf-head__bar" />
      <span class="bdf-head__title">保证金未退还</span>
      <span class="bdf-head__badge">{{ data.total }} 笔 · {{ formatAmount(data.total_amount) }}</span>
    </div>
    <div class="bdf-body">
      <div
        v-for="(item, i) in displayList"
        :key="item.id || i"
        class="bdf-row"
        :class="{'bdf-row--warn': item.overdue_days > 0, 'bdf-row--empty': !item.id}"
        @click="item.id && goOpen()"
      >
        <span class="bdf-row__time">{{ item.id ? rowTime(item) : '' }}</span>
        <span class="bdf-row__dot" :class="{'bdf-row__dot--warn': item.overdue_days > 0}" />
        <div class="bdf-row__main">
          <div class="bdf-row__text">{{ item.name || '—' }}</div>
          <div v-if="item.id" class="bdf-row__sub">
            <span>{{ formatAmount(item.deposit_amount) }}</span>
            <span v-if="item.overdue_days > 0" class="bdf-row__warn">逾期 {{ item.overdue_days }} 天</span>
            <span v-else>应退 {{ formatDate(item.deadline) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import {USE_MOCK, formatAmount, mockBonds} from './bid-dashboard-mock';
import {FEED_SIZE} from './bid-dashboard-theme';

export default {
  data() {
    return {data: {total: 0, total_amount: 0, list: []}};
  },
  computed: {
    displayList() {
      const list = (this.data.list || []).slice(0, FEED_SIZE);
      while (list.length < FEED_SIZE) list.push({});
      return list;
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    formatAmount,
    loadData() {
      if (USE_MOCK) {
        this.data = mockBonds();
        return;
      }
      this.$api.get('/business/bid/dashboard/unreturned-bonds', {limit: FEED_SIZE}).then((res) => {
        this.data = res.data.data;
      }).catch(() => {
        this.data = mockBonds();
      });
    },
    formatDate(d) {
      return d ? moment(d).format('MM/DD') : '';
    },
    rowTime(item) {
      if (item.overdue_days > 0) return `逾期${item.overdue_days}天`;
      return this.formatDate(item.deadline);
    },
    goOpen() {
      const base = this.$route.path.replace(/\/[^/]+$/, '');
      this.RouteTo(`${base}/open`);
    },
  },
};
</script>

<style lang="less" scoped>
.bdf {
  height: 100%;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #fde68a;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.bdf-head {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background: #fffbeb;
  border-bottom: 1px solid #fef3c7;
  flex-shrink: 0;
}

.bdf-head__bar {
  width: 3px;
  height: 11px;
  background: #d97706;
  border-radius: 2px;
}

.bdf-head__title {
  font-size: 13px;
  font-weight: 700;
  color: #92400e;
}

.bdf-head__badge {
  margin-left: auto;
  font-size: 12px;
  color: #d97706;
  font-weight: 600;
}

.bdf-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding: 2px 0;
}

.bdf-row {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 8px;
  border-bottom: 1px dashed #fef3c7;
  cursor: pointer;
  min-height: 0;

  &:last-child { border-bottom: none; }
  &:hover:not(&--empty) { background: #fffbeb; }
  &--empty { opacity: 0.25; cursor: default; }
  &--warn .bdf-row__text { color: #92400e; }
}

.bdf-row__time {
  width: 48px;
  flex-shrink: 0;
  font-size: 9px;
  color: #d97706;
  text-align: right;
}

.bdf-row__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fde68a;
  flex-shrink: 0;

  &--warn { background: #d97706; }
}

.bdf-row__main {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.bdf-row__text {
  font-size: 12px;
  font-weight: 600;
  color: #1e3a5f;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
}

.bdf-row__sub {
  flex-shrink: 0;
  font-size: 10px;
  color: #9cb8d8;
  display: flex;
  gap: 6px;

  span:first-child {
    color: #d97706;
    font-weight: 700;
  }
}

.bdf-row__warn {
  color: #92400e !important;
  font-weight: 600;
}
</style>
